const base = {
  state: {
    data: [
		{
      name: "首页",
      path: "/home",
      url: "/home",
      img: "el-icon-house",
      childs:[{
        name: "首页",
        url: "/home",
        img: "icon-jichushuju",
      }]
    },
  ]
  },
  mutations: {
    set_authMenuData:(state, value) => {
      state.authMenuData = value
    },
  },
  getters: {
    //授权数据
    authMenuData: (state) => {
      return state.data
    }
  }
}

export default base

